export default class Triangle {
    constructor() {
        this.a, this.b, this.c, this.A, this.B, this.C, this.hA, this.hB, this.hC;
    }
}
